import { createAction, props } from '@ngrx/store';

export const loadBalances = createAction('[Balances] Load');

export const setBalances = createAction('[Balances] Set', props<{ balances: any }>());

export const updateBalance = createAction('[Balances] Update', props<{ balances: any }>());

export const stopUpdating = createAction('[Balances] Stop updating');
